export enum TerminalSetWorkingModeRequest {
  Standard = 0,
  LoopEnteringsOpens = 1,
  NonTicketWithPlates = 2,
}
